import type {
  PageableResponse,
  Player,
  SingleRecordResponse,
} from '~/types'

export const usePlayerApi = () => {
  const view = (slug: string, params: MaybeRef<Player.SearchRequest> = {}) => {
    return useApiGet<SingleRecordResponse<Player.Model>>(`/players/${slug}`, { params: unref(params) })
  }

  const search = (params: MaybeRef<Player.SearchRequest> = {}) => {
    return useApiGet<PageableResponse<Player.Model>>('/players', { params: unref(params) })
  }

  return { view, search }
}
